"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../styles/WhatYourNeedComponent.css");
const WaterGoingModalComponent = _ref => {
  let {
    modalHeaderText,
    learnMoreText,
    imageData
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "what-you-need-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: modalHeaderText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "learnMoreText"
  }, learnMoreText), /*#__PURE__*/_react.default.createElement("div", {
    className: "what-you-need-wrapper-images"
  }, imageData === null || imageData === void 0 ? void 0 : imageData.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: "20px"
      },
      key: index
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: item
    }));
  })));
};
var _default = exports.default = WaterGoingModalComponent;